/* eslint-disable import/no-cycle */
/**
 * replacements for html-react-parser
 * documentation here: https://github.com/remarkablemark/html-react-parser#readme
 * array of functions, each should take arg domNode, plus optional addToCollection fn
 * {name, attribs, type, parent, children, prev, next, startIndex, endIndex}, addToCollection
 * and return a React element to replace the domNode, or null/falsy to use default replacement
 * Stops replacing after a truthy return value; earlier rules take precedence.
 * addToCollection(key, value) --
 *       adds value to array in parsedCollection[key], and returns the appended array
 */

import { assembleReplacements } from '../helpers';
import conditionalCss from './conditionalCss';
import stripLegacySchema from './stripLegacySchema';
import toAccountsList from './toAccountsList/toAccountsList';
import toCtaCard from './toCtaCard';
import toFAQ from './toFAQ';
import toFootnote from './toFootnote';
import toTooltip from './toTooltip';
import toGatsbyImage from './toGatsbyImage';
import toHowTo from './toHowTo';
import toLearningCenterSourceIdInlineLink from './toLearningCenterSourceIdInlineLink';
import toList from './toList';
import toMultiCTA from './toMultiCTA';
import toPrimaryCTA from './toPrimaryCTA/toPrimaryCTA';
import toSingleCTA from './toSingleCTA';
import toTable from './toTable';
import toResourcesTile from './toResourcesTile';
import toTrustPilot from './toTrustPilot/toTrustPilot';
import toSpotlightGrid from './toSpotlightGrid';
import toTypography from './toTypography';
import withCtaLink from './withCtaLink';
import toCalculator from './toCalculator';
import toMarketplace from './toMarketplace';
import toCustomOfferCard from './toCustomOfferCard';
import toEmbedVideo from './toEmbedVideo';
import toCalloutBox from './toCalloutBox/toCalloutBox';
import toInfoBox from './toInfoBox/toInfoBox';
import toIndentedText from './toIndentedText';
import toTableOfContent from './toTableOfContent';

// @NOTE: order of parsers is important!
export const learningCenterReplacements = (pageData) =>
{
    const parserOptions = {
        replaceFn: () => ({
            replace: assembleReplacements(learningCenterReplacements(pageData)),
        }),
    };
    const parserData = {
        ...pageData,
        parserOptions,
    };
    return [
        stripLegacySchema,
        toGatsbyImage(),
        toFootnote(parserData),
        toTooltip.content( parserData ),
        toTooltip( parserData ),
        toFAQ(parserData),
        toHowTo(parserData),
        toPrimaryCTA(parserData),
        toCtaCard(parserData),
        toResourcesTile(parserData),
        toAccountsList(parserData),
        toSingleCTA(parserData),
        toLearningCenterSourceIdInlineLink(parserData),
        toTypography(parserData),
        toList(parserData),
        toTable(parserData),
        toMultiCTA(parserData),
        toTrustPilot(parserData),
        toSpotlightGrid(parserData),
        conditionalCss(),
        toCalculator(),
        toMarketplace(parserData),
        toCustomOfferCard(parserData),
        toEmbedVideo(),
        toCalloutBox(parserData),
        toInfoBox(parserData),
        toIndentedText(parserData),
        toTableOfContent(parserData),
    ];
};
const coreReplacements = ({ location }) => [withCtaLink(location)];

export default coreReplacements;
